import api from 'src/services/api';
import {
  GestionErroresDetalleResponse,
  GestionErroresResumenResponse,
} from 'src/modules/gestionErrores/types';

const buildParams = (fechaDesde?: string, fechaHasta?: string) => {
  if (!fechaDesde || !fechaHasta) return undefined;
  return { fecha_desde: fechaDesde, fecha_hasta: fechaHasta };
};

export const GestionErroresAPI = {
  async resumen(fechaDesde?: string, fechaHasta?: string) {
    const params = buildParams(fechaDesde, fechaHasta);
    const res = await api.get<GestionErroresResumenResponse>('gestion_errores/resumen', { params });
    return res.data;
  },

  async detalle(psId: number, fechaDesde?: string, fechaHasta?: string) {
    const params = buildParams(fechaDesde, fechaHasta);
    const res = await api.get<GestionErroresDetalleResponse>(`gestion_errores/detalle/${psId}`, { params });
    return res.data;
  },
};
